module.exports = __webpack_public_path__ + "static/media/jcb-logo-charcoal.7ed05d60.svg";